import { Dispatch } from "redux";
import {QuicktipCreateActionTypes, QuicktipCreateAction} from "../../types/Quicktip/quicktipCreateTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const createQuicktip = (data: any): any => {
    return async (dispatch: Dispatch<QuicktipCreateAction>) => {
        try {
            dispatch({ type: QuicktipCreateActionTypes.FETCH_QUICKTIP_CREATE_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/quicktips/create`,
                data: data,
                withCredentials: false
            });
            dispatch({ type: QuicktipCreateActionTypes.FETCH_QUICKTIP_CREATE_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuicktipCreateActionTypes.FETCH_QUICKTIP_CREATE_DATA_ERROR, payload: errorPayload });
        }
    }
}
